module.exports = __webpack_public_path__ + "media/klaseaDia1Barco1.12d29190.mp4";